module.exports = __webpack_public_path__ + "img/img4.809a189a.png";